/**
 * Textos do recorte manual na aba Documentos (E214.F1, GUS-314): o perito abre um documento do
 * caso, escolhe a página, desenha a área e diz o que ela é. O original não muda; o recorte segue
 * para a comparação facial, para a leitura do documento de identidade ou para a leitura do crédito.
 */
export const ptBRRecorteDoDocumento = {
  botao: 'Recortar',
  botaoDe: 'Recortar uma área de {nome}',
  titulo: 'Recortar uma área do documento',
  descricao:
    'Escolha a página, desenhe a área com o mouse e diga o que ela é. O arquivo original não é alterado.',
  pagina: 'Página {n} de {total}',
  paginaSemTotal: 'Página {n}',
  anterior: 'Página anterior',
  proxima: 'Próxima página',
  carregandoPagina: 'Carregando a página…',
  erroDaPagina: 'Não foi possível mostrar esta página.',
  tentarDeNovo: 'Tentar de novo',
  desenhe: 'Arraste sobre a página para marcar a área.',
  areaMarcada: 'Área marcada. Ajuste pelos cantos, se precisar.',
  desenharDeNovo: 'Marcar outra área',
  oQueE: 'O que é esta área?',
  destino: {
    identidade_frente: 'Documento de identidade (frente, com a fotografia)',
    identidade_verso: 'Documento de identidade (verso, com os dados)',
    selfie: 'Selfie/FotoDocContrato da formalização',
    comprovante_ted: 'Comprovante de TED',
  },
  ajudaDoDestino: {
    identidade_frente: 'Entra na comparação facial, que é refeita.',
    identidade_verso: 'Os dados são lidos e aparecem aqui para você confirmar.',
    selfie: 'Entra na comparação facial, que é refeita.',
    comprovante_ted: 'O comprovante é lido sem digitação.',
  },
  salvar: 'Salvar o recorte',
  salvando: 'Salvando…',
  cancelar: 'Cancelar',
  fechar: 'Fechar',
  faltaArea: 'Marque a área na página.',
  faltaDestino: 'Escolha o que é a área.',
  resultado: {
    foto: 'Recorte salvo. A comparação facial está sendo refeita.',
    verso: 'Recorte salvo. A leitura do verso aparece na linha do documento para você confirmar.',
    credito_lido: 'Comprovante lido. Os dados do crédito já estão no exame.',
    credito_nao_lido:
      'Comprovante recebido, mas este formato de comprovante ainda não é lido. Nenhum campo é digitado.',
  },
  porQue: {
    concluido:
      'Há peça do exame concluída: a comparação facial não muda mais. Reabra a peça para trocar a fotografia.',
    pagina: 'Esta página não existe no documento.',
    formato: 'Este arquivo não tem páginas para recortar. Use um PDF ou uma imagem.',
    original: 'O arquivo guardado não confere com o registro do recebimento. Nada foi recortado.',
    nao_encontrado: 'O documento não está mais no caso.',
    falha: 'Não foi possível salvar o recorte. Tente novamente.',
  },
} as const;
